import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiStar, FiTarget, FiColumns, FiAward, FiGift } = FiIcons;

const EngagementHighlights = ({ entries = [], prizes = [], gameMode = '' }) => {
  const safeEntries = Array.isArray(entries) ? entries : [];
  const winners = safeEntries.filter(e => e && typeof e.reward === 'string' && !e.reward.includes('Luck') && !e.reward.includes('Try'));
  
  if (winners.length === 0) {
    if (!prizes || !Array.isArray(prizes) || prizes.length === 0) return null;
    return (
      <div className="mt-8 w-full max-w-2xl mx-auto lg:mx-0">
        <h3 className="text-slate-500 dark:text-slate-400 text-xs font-bold uppercase tracking-widest mb-3 flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-amber-500 animate-pulse"></span>
          Dynamic Prize Highlights ({gameMode || 'Lucky Draw'})
        </h3>
        <div className="flex flex-wrap gap-2">
          {prizes.slice(0, 5).map((p, idx) => (
            <span key={idx} className="px-3 py-1.5 rounded-xl bg-white/80 dark:bg-slate-800/80 border border-slate-200 dark:border-slate-700 text-xs font-bold text-slate-800 dark:text-slate-200 shadow-sm flex items-center gap-1.5">
              <span>🎁</span> {p}
            </span>
          ))}
        </div>
      </div>
    );
  }

  // Intelligently pick highlights based on game types
  const hourlyStar = winners[0]; // Most recent winner
  const spinWinner = winners.find(e => e.gameType === 'Spin Wheel' && e.id !== hourlyStar?.id) || winners[1];
  const slotWinner = winners.find(e => e.gameType === 'Slot Machine' && e.id !== hourlyStar?.id && e.id !== spinWinner?.id) || winners[2];

  // Compile unique highlights
  const rawHighlights = [
    { title: "First Hour Winner 🌟", winner: hourlyStar, icon: FiStar, color: "text-amber-500", bg: "bg-amber-500/10 border-amber-500/20" },
    { title: "Spin Master 🎯", winner: spinWinner, icon: FiTarget, color: "text-blue-500", bg: "bg-blue-500/10 border-blue-500/20" },
    { title: "Jackpot Hitter 🎰", winner: slotWinner, icon: FiColumns, color: "text-red-500", bg: "bg-red-500/10 border-red-500/20" }
  ];

  const highlights = rawHighlights.filter(h => h.winner);

  return (
    <div className="mt-10 w-full max-w-2xl mx-auto lg:mx-0">
      <h3 className="text-slate-400 text-xs font-bold uppercase tracking-widest mb-4 flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
        Live Event Highlights
      </h3>
      
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {highlights.map((item, idx) => (
          <motion.div 
            key={idx}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: idx * 0.2 }}
            className={`rounded-xl p-4 border ${item.bg} backdrop-blur-md relative overflow-hidden`}
          >
            <div className="flex items-center gap-2 mb-2">
              <SafeIcon icon={item.icon} className={`${item.color} text-lg`} />
              <span className={`text-xs font-bold ${item.color} uppercase`}>{item.title}</span>
            </div>
            <div className="font-bold text-white truncate">{item.winner.name}</div>
            <div className="text-xs text-slate-300 truncate mt-0.5">Won: <span className="font-semibold text-emerald-400">{item.winner.reward}</span></div>
            
            <SafeIcon icon={FiAward} className="absolute -bottom-4 -right-4 text-6xl text-white/5 rotate-12 pointer-events-none" />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default EngagementHighlights;